import React, { useEffect, useState } from 'react';
import Moment from 'moment';
import OrdersService from "services/Orders/";
import Link from "components/Link";
import PropTypes from 'prop-types';
import PubSub from "services/PubSub/";
import Loader from 'components/Loader';
import { withRouter } from "react-router";
import truckIcn from 'images/menu/truck-1.svg'
import CustomSelect from "components/CustomSelect";
import RadioButton from 'components/RadioButton';
import style from './style.scss'; //NOSONAR


let actions = [];

const OrderTracking = (props) => {
    const [orders, setOrders] = useState([]);
    const [showOrders, setShowOrders] = useState(false);
    const [orderSelected, setOrderSelected] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isMobile, setMobile] = useState(false);

    useEffect(()=>{
        actions.push(PubSub.register('close_tracking', () => setShowOrders(false)));

        if (window) {
            checkViewport();
        }

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const checkViewport = ()  => {
        if(!document) return false;
        const $body = document.querySelector('body');
        let viewportWidth = $body.clientWidth;
        let currentIsMobile = viewportWidth <= 1120;

        (currentIsMobile) ? setMobile(true) : setMobile(false);
    };

    const getOrders = () => {
        let allOrders = [];

        OrdersService.getLastOrders().then(results => {
            results = results ? results : [];
            allOrders = allOrders.concat(results);
            let orderIds = [];
            allOrders.map((result) => {
                return orderIds = orderIds.concat({ value: result.orderId, label: result.orderId, creationDate: result.creationDate ? Moment(result.creationDate).locale("es").format('L') : '-'});
            })

            setOrders(orderIds);
            setIsLoading(false);
            if(orderIds[0]){
                setOrderSelected(orderIds[0]);
            }
        });
    }

    const showAllOrders = () => {
        getOrders();
        checkViewport();
        if(!isMobile) PubSub.dispatch('toggle_menu', { state: false });
        PubSub.dispatch('toggle_minicart', {state: false});
        setShowOrders(!showOrders);
    }

    const selectOrder = (selectedOption) => {
        setOrderSelected(selectedOption);
    }

    const selectMobile = (order) => {
        selectOrder(order);
    }

    const showOrder = () => {
        setShowOrders(false);
        PubSub.dispatch('toggle_menu', { state: false });
        props.history.push(`/_secure/orderDetail/${orderSelected.value}`);
    }

    return <div className="new-header-order-tracking-wrap">
        <button className="new-header-order-tracking-button" onClick={()=>showAllOrders()}>
            <div dangerouslySetInnerHTML={{ __html: truckIcn }} className="menu-icon"></div>
            Estado del pedido
        </button>
        <div className={'new-header-order-tracking' + (showOrders ? ' active': '')} onMouseLeave={() => {(!isMobile) && setShowOrders(false)}}>
            {(!isLoading && (orders.length === 0)) && <>
                No tienes pedidos activos
                <Link to="/busca?fq=H%3A3416&nombre_promo=boton-ofertas-home08072019" className="traking-offers-link">Ver ofertas</Link>
            </>}
            {(!isLoading && (orders.length > 0)) && <>

                {!isMobile && <>
                    <strong className="orders-title">Selecciona tu pedido</strong>
                    <CustomSelect options={orders} onChange={selectOrder} value={orderSelected}/>
                </>}
                {isMobile && <>
                    <strong className="orders-title">Estado de pedido</strong>
                    <span>Selecciona una orden de tus compras activas y revisa su estado actual.</span>
                    <div className="orders-info-title-mobile">
                        <strong>Número de orden</strong>
                        <strong>Fecha</strong>
                    </div>
                    <form>
                        {orders.map((order) => {
                            return (
                                <label key={order.value} className={'new-header-orders' + ((orderSelected && orderSelected.value === order.value) ? ' active' : '')} onClick={()=> selectMobile(order)}>
                                    <RadioButton item={(orderSelected && orderSelected.value === order.value)} value={order.value} name={'order-tracking'}  />
                                    <span className="order-tracking-orders">{order.value}</span>
                
                                    <strong>{order.creationDate}</strong>
                                </label>
                            )
                        })}
                    </form>
                </>}
                <button aria-label="Ver orden seleccionada" onClick={()=>showOrder()} className="primary-btn show-order">Ver</button>
                {isMobile && <button className="close-tracking-orders" onClick={()=>setShowOrders(false)}>volver</button>}
            </>}
            {isLoading && <Loader/>}
        </div>
    </div>
};

OrderTracking.propTypes = {
    history: PropTypes.object
};

export default withRouter(OrderTracking);

